import React from 'react';
import { useSelector } from 'react-redux';
import stylesContent from './Content.module.scss';

import DatiPersonali from '../Steps/1__DatiPersonali/DatiPersonali';
import Contatti from '../Steps/2__Contatti/Contatti';
import Iban from '../Steps/3__Iban/Iban';
import PersonaEsposta from '../Steps/4__PersonaEsposta/PersonaEsposta';
import Cittadinanza from '../Steps/5__Cittadinanza/Cittadinanza';
import Civile from '../Steps/6__Civile/Civile';
import Residenza from '../Steps/7__Residenza/Residenza';
import DocumentoIdentificativo from '../Steps/8__DocumentoIdentificativo/DocumentoIdentificativo';
import SituazioneLavorativa from '../Steps/9__SituazioneLavorativa/SituazioneLavorativa';
import RedditoMensile from '../Steps/10__RedditoMensile/RedditoMensile';
import Questionario from '../Steps/11__Questionario/Questionario';
import Riepilogo from '../Steps/12__Riepilogo/Riepilogo';
import CaricamentoDocumenti from '../Steps/13__CaricamentoDocumenti/CaricamentoDocumenti';
import CaricamentoDocumentiSecondari from '../Steps/15__CaricamentoDocumentiSecondari/CaricamentoDocumentiSecondari';

const Content = () => {

    const steps = useSelector(state => state.dataReducer.modello.currentStep);

    return(
        <div className={stylesContent.Content}>
            <div className={stylesContent.ContentCenter}>
                {
                    steps === 1 ? <DatiPersonali  />
                    : steps === 2 ? <Contatti />
                    : steps === 3 ? <Iban />
                    : steps === 4 ? <PersonaEsposta />
                    : steps === 5 ? <Cittadinanza />
                    : steps === 6 ? <Civile />
                    : steps === 7 ? <Residenza />
                    : steps === 8 ? <DocumentoIdentificativo  />
                    : steps === 9 ? <SituazioneLavorativa />
                    : steps === 10 ? <RedditoMensile />
                    : steps === 11 ? <Questionario  />
                    : steps === 12 ? <Riepilogo  />
                    : steps === 13 ? <CaricamentoDocumenti />
                    : steps === 15 ? <CaricamentoDocumentiSecondari />
                    : null
                }
            </div>
        </div>
    )
}

export default Content;